import { z } from "zod";
import { ProteinSearchInputResultSchema } from "../protein_search/schemas";

export const GaiaAgentRequestSchema = z.object({
  proteinRecord: ProteinSearchInputResultSchema,
  pdbStructure: z.string().nullable(),
});
export type GaiaAgentRequest = z.infer<typeof GaiaAgentRequestSchema>;

export const GaiaAgentResponseSchema = z.object({
  id: z.number(),
  shortPrediction: z.string(),
  longPrediction: z.string(),
  foldseekTicket: z.string().nullable(),
});
export type GaiaAgentResponse = z.infer<typeof GaiaAgentResponseSchema>;

export const GaiaAgentRatingRequestSchema = z.object({
  predictionId: z.number(),
  reaction: z.union([z.literal("thumbs_up"), z.literal("thumbs_down")]),
});
export type GaiaAgentRatingRequest = z.infer<
  typeof GaiaAgentRatingRequestSchema
>;
export const GaiaAgentRatingResponseSchema = z.object({
  status: z.literal("ok"),
});
export type GaiaAgentRatingResponse = z.infer<
  typeof GaiaAgentRatingResponseSchema
>;
